const C = require("../constants");
const initial_data = {open: false};

function PaymentsDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PAYMENTS_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default PaymentsDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/PaymentsDialogReducer.js